"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getMeshInfo = void 0;
const getMeshInfo = (profile) => ({
    meshApiRev: profile.mesh.version,
    passphrase: profile.mesh.passphrase,
    mqttURLInfo: {
        url: profile.mesh.url.endpoint,
        expirationTime: new Date(profile.mesh.url.expirationTime),
    },
});
exports.getMeshInfo = getMeshInfo;
//# sourceMappingURL=Mesh.js.map